define('uikit/elements/dropdown',['require','exports','module','underscore','backbone','marionette','../channel','../helper/browser','../mixins/component.mixin','templates','../extra/size','../extra/color','../extra/floated','handlebars','../extra/extend.util','../definitions/modules/dropdown','../definitions/modules/transition'],function(require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Mn = require('marionette');
  var channel = require('../channel');
  var browser = require('../helper/browser');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates = require('templates');
  var Size = require('../extra/size');
  var Color = require('../extra/color');
  var Floated = require('../extra/floated');
  var Handlebars = require('handlebars');
  var ExtendUtil = require('../extra/extend.util');

  require('../definitions/modules/dropdown');
  require('../definitions/modules/transition');

  var BUTTON_MODE = 'button';
  var SELECT_MODE = 'select';

  var DropDownItemView = Mn.CompositeView.extend(ComponentMixin).extend({
    className: 'item',

    allowTagChange: true,

    options: {
      text: '',
      color: '',
      description: '',
      disabled: '',
      icon: '',
      link: '',
      hasAction: false,
      imageUrl: '',
      imageHeight: '',
      imageWidth: '',
      imageAlt: '',
      target: '',
      menuDirection: 'right',
      fluid: false,
      value: null,
    },

    forceUpdate: {
      text: true,
      color: true,
      description: true,
      disabled: true,
      icon: true,
      link: true,
      target: true,
      imageUrl: true,
      imageHeight: true,
      imageWidth: true,
      imageAlt: true,
      menuDirection: true,
    },

    childView: DropDownItemView,

    triggers: {
      click: {
        event: 'press',
        preventDefault: false,
        stopPropagation: false,
      },
    },

    onFirstRender: function() {
      var dropdownView = this.getOption('dropdownView'),
        self = this;

      if (this.collection instanceof Backbone.Collection) {
        this.listenTo(
          this.collection,
          'add remove reset',
          _.debounce(function() {
            var value = dropdownView.getValueForDropdown(this.value);
            dropdownView._updateValue(value, this);
          }, 1)
        );
      }
      this.on(
        'change:value',
        _.debounce(function() {
          var value = dropdownView.getValueForDropdown(this.value);
          dropdownView._updateValue(value, this);
        }, 1),
        this
      );

      if (this.value) {
        _.defer(function() {
          var value = dropdownView.getValueForDropdown(self.value);
          dropdownView._updateValue(value, self);
        });
      }
    },

    childViewContainer: ' > .menu',

    onBeforeAddChild: function(childView) {
      childView.dropdownView = this.getOption('dropdownView');
      childView.collection = childView.bindings.get('collection');
      childView.index = this.collection.indexOf(childView.model);
    },

    updateAttributes: function() {
      // Don't allow dropdown items to be tabbable, they should be navigatable using arrow keys
      this.$el.attr('tabindex', -1);

      this.$el.attr('data-value', this.getOption('dropdownView')._getModelId(this.model));

      if (this.bindings.get('link')) {
        this.$el.attr('href', this.bindings.get('link'));
        if (this.target) {
          this.$el.attr('target', this.target);
        }
      } else {
        this.$el.removeAttr('href');
      }

      this.addClass('disabled', this.getBoolOption('disabled')).addClass('link', this.getBoolOption('hasAction'));
    },

    serializeData: function() {
      var data = ComponentMixin.serializeData.apply(this, arguments),
        ddv = this.getOption('dropdownView');

      if (ddv) {
        data.fluid = ddv.getBoolOption('fluid');
      }

      data.hasChildren = this.collection instanceof Backbone.Collection;

      return data;
    },

    template: Templates.App['dropdown.itemview'],
  });

  var DropDownHeaderView = Mn.ItemView.extend({
    className: 'header',
    template: function(data) {
      var str = '';
      if (data.icon) {
        str += '<i class="' + Handlebars.escapeExpression(data.icon) + ' icon"></i> ';
      }
      str += Handlebars.escapeExpression(data.text);
      return str;
    },
  });

  var DropDownDividerView = Mn.ItemView.extend({
    className: 'divider',
    template: false,
  });

  var DropDownHeaderModel = Backbone.Model.extend({});
  var DropDownDividerModel = Backbone.Model.extend({});

  var Dropdown = Mn.CompositeView.extend(ComponentMixin).extend(
    {
      className: 'ui dropdown',

      template: Templates.App['dropdown'],

      options: {
        activation: 'click',
        bindCollectionLoading: false,
        circular: false,
        clearable: false,
        collection: null,
        color: '',
        customFilter: false,
        direction: 'down',
        disabled: false,
        error: false,
        floated: '',
        floating: false,
        fluid: false,
        focusable: true,
        forceSelection: true,
        fullTextSearch: false,
        header: '',
        icon: 'dropdown',
        iconOnly: false,
        iconRight: true,
        inline: false,
        inverted: false,
        labeled: false,
        loading: false,
        mode: 'select',
        placeholder: null,
        pointing: '',
        preserveHTML: true,
        search: false,
        size: '',
        state: null,
        text: null,
        textColor: null,
        useIdAsValue: false,
        value: null,
        visible: true,
        basic: false,
        readonly: false,
        defaultValueToFirstModel: false,
      },

      colorOptionValues: _.values(Color),
      sizeOptionValues: _.values(Size),
      floatedOptionValues: _.values(Floated),
      modeOptionValues: ['select', 'button'],

      forceUpdate: {
        activation: true,
        clearable: true,
        color: true,
        direction: true,
        error: true,
        floated: true,
        fluid: true,
        focusable: true,
        header: true,
        icon: true,
        iconOnly: true,
        iconRight: true,
        inline: true,
        labeled: true,
        mode: true,
        placeholder: true,
        pointing: true,
        search: true,
        text: true,
        textColor: true,
        visible: true,
      },

      events: {
        mousedown: function() {
          this._cancelNextFocus = false;
        },
        'mousedown .item': function(ev) {
          if (this.search) {
            var $item = $(ev.currentTarget),
              className = $.fn.dropdown.settings.className;
            // this fixes a bug where searching selecting the active
            // item causes the dropdown to go blank
            $item.removeClass(className.active);
          }
        },
        'click .item': function(ev) {
          if (!$.support.transition) {
            this._cancelNextFocus = true;
          }
        },
        focus: function(ev) {
          if (this._cancelNextFocus || (this.readonly || this.disabled)) {
            this._cancelNextFocus = false;
            ev.stopImmediatePropagation();
            ev.preventDefault();
            return false;
          }
        },
        keydown: function(ev) {
          if (ev.keyCode == 40 && (this.readonly || this.disabled)) {
            ev.stopImmediatePropagation();
            ev.preventDefault();
            return false;
          }

          if (ev.keyCode == 13) {
            var selectedItem = this.$el.find('> .menu .item.selected');

            if (selectedItem.length > 0) {
              selectedItem.get(0).click();
            }
          }
        },
        'keydown @ui.searchInput': function(ev) {
          var keyCode = ev.which || ev.keyCode,
            // must use selector because search does not
            // exist at render time
            $search = this.$('> input.search'),
            self = this;

          if (keyCode == 13 || keyCode == 9) {
            this._startingSearchInput = false;
            this.triggerMethod('search:enter', $search.val(), ev);
          } else if (keyCode == 27) {
            this._startingSearchInput = false;

            // Clear selection and hide dropdown
            this.$el.dropdown('clear');
            this.$el.dropdown('hide');
          } else {
            _.defer(function() {
              var value = $search.val();
              if (value !== self._searchValue) {
                self._searchValue = value;
                self.triggerMethod('search:value', $search.val(), ev);
              }
            });
          }
        },
        'blur @ui.searchInput': function(ev) {
          if (this._startingSearchInput) {
            var val = this.$('> input.search').val();
            this.triggerMethod('search:blur', val, ev);
            this._startingSearchInput = false;
          }
        },
        'focus @ui.searchInput': function() {
          if (this._startingSearchInput !== true) {
            this._startingSearchInput = true;
            this._searchValue = this.ui.searchInput.val();
            this.triggerMethod('search:start');
          }
          this.triggerMethod('search:focus');
        },
        'click > .ui.clear.button': 'onClearBtnClick',
        'click .menu .item': 'onItemClick',
      },

      childViewContainer: ' > .menu',

      attributes: {
        tabindex: '0',
      },

      ui: {
        menu: '> .menu',
        searchInput: '> input.search',
        clearBtn: '> .ui.clear.button',
      },

      initialize: function() {
        ComponentMixin.initialize.apply(this, arguments);

        this.on('render', this.setupDropdownComponent, this);
      },

      getChildView: function(model) {
        if (model instanceof DropDownHeaderModel) {
          return DropDownHeaderView;
        } else if (model instanceof DropDownDividerModel) {
          return DropDownDividerView;
        }

        return DropDownItemView;
      },

      buildChildView: function(child, ChildViewClass, childViewOptions) {
        childViewOptions = _.extend(
          {
            dropdownView: this,
          },
          childViewOptions
        );
        ChildViewClass = ExtendUtil.extendClassBehaviors(ChildViewClass, childViewOptions);
        return Mn.CompositeView.prototype.buildChildView.call(this, child, ChildViewClass, childViewOptions);
      },

      _getPropertyForModel: function(model, property) {
        return (
          (this.getPropertyForModel && this.getPropertyForModel(model, property)) ||
          model.get(this.getOption(property + 'Field'))
        );
      },

      onSearchEnter: function(searchValue, ev) {
        this.checkItemAdd(searchValue, ev);
      },

      onSearchBlur: function(searchValue, ev) {
        if (searchValue) {
          this.checkItemAdd(searchValue, ev);
        }
      },

      checkItemAdd: function(searchValue, ev) {
        var className = $.fn.dropdown.settings.className,
          selector = $.fn.dropdown.settings.selector,
          $currentlySelected = this.$(selector.menu + ' ' + selector.item + '.' + className.selected)
            .not('.' + className.filtered)
            .eq(0);

        if ($currentlySelected.length == 0) {
          this.triggerMethod('item:add', searchValue, ev);
        }
      },

      _initialEvents: function() {
        Mn.CompositeView.prototype._initialEvents.apply(this, arguments);

        // Only proceed if there is a collection
        if (!this.collection) {
          return;
        }

        this.listenTo(
          this.collection,
          'add remove reset',
          _.debounce(function() {
            var dropdownModule = this.$el.data('moduleDropdown');
            // only update the internal value if the dropdown module
            // is not active
            if (!dropdownModule || !dropdownModule.is.active()) {
              var value = this.getValueForDropdown(this.value);
              this._updateValue(value, this);
            }
          }, 1)
        );

        if (this.bindCollectionLoading) {
          this.listenTo(this.collection, 'request', function() {
            this.loading = true;
          }).listenTo(this.collection, 'sync error', function() {
            this.loading = false;
          });
        }
      },

      onFirstRender: function() {
        // dropdown updates its internal list of $items by using a mutation observer
        // if a browser does not support mutation observers
        // then we need to manually trigger a refresh whenever the child items change
        // i.e. whenever add:child or remove:child is called
        if (!('MutationObserver' in window)) {
          this.on(
            'add:child remove:child',
            function() {
              // call refresh on the dropdown
              // to update its internal references to $item
              this.$el.dropdown('refresh');
            },
            this
          );
        }
        this.on(
          'change:value',
          _.debounce(function() {
            var value = this.getValueForDropdown(this.value);
            this._updateValue(value, this);
          }, 1),
          this
        );
      },

      setupDropdownComponent: function() {
        var action,
          self = this,
          noResults = false;

        if (!this.getBoolOption('focusable')) {
          this.$el.removeAttr('tabindex');
        }

        if (this._isRendered) {
          this.$el.dropdown('clear');
        } else {
          // this is a special case for dropdown because
          // certain classnames need to be set before
          // the dropdown module initializes
          this.updateAttributes();
        }

        // if button mode then we just hide the dropdown
        // and never persist the state of the selection
        if (this.getOption('mode') == 'button') {
          action = 'hide';
        } else {
          // if we have text then we never want to activate the selected item
          if (this.getOption('text')) {
            action = 'select';
          } else {
            action = 'activate';
          }
        }

        this.$el.removeClass('visible').dropdown({
          transition: browser.isIE() == '9' ? 'slide down' : 'auto',
          action: action,
          on: this.getOption('activation'),
          fullTextSearch: this.fullTextSearch,
          forceSelection: this.forceSelection,
          preserveHTML: this.preserveHTML,
          metadata: {
            defaultText: this.placeholder,
            defaultValue: null,
          },
          onChange: function() {
            if (self._hasSetInitialValue) {
              self._onDropdownChange.apply(self, arguments);
            }
          },
          onNoResults: function() {
            noResults = true;
          },
          onShow: function() {
            if (!$.support.transition) {
              // this browser does not support transitions
              self.$('> .menu').transition('set visible');
            }

            self.triggerMethod('dropdown:show');
          },
          onHide: function() {
            if (self.search === true) {
              _.defer(function() {
                if (noResults) {
                  noResults = false;
                }
              });
            }
            var $menu = self.$('> .menu'),
              transitionModule = $menu.data().moduleTransition;

            if (transitionModule && $.support.transition && transitionModule.is.animating()) {
              $menu.one(transitionModule.get.animationEndEvent(), function() {
                $menu.transition('remove visible').transition('remove hidden');
              });
            } else {
              $menu.transition('remove visible').transition('remove hidden');
            }

            self.triggerMethod('dropdown:hide');
          },
        });

        var dropdownModule = this.$el.data('moduleDropdown');

        if (dropdownModule) {
          // this function causes so many problems
          // that I am overriding it so it can stop
          // being so shitty
          dropdownModule.focusSearch = function() {};
        }

        if (dropdownModule && this.customFilter) {
          // override how the dropdown module filters its results
          dropdownModule.filter = _.bind(function(searchTerm) {
            this._customDropdownFilter(searchTerm, dropdownModule);
          }, this);
          this.on('search:start', function() {
            if (dropdownModule.can.show()) {
              dropdownModule.show();
            }
          });
          if (this.collection) {
            this.listenTo(
              this.collection,
              'add remove reset',
              _.debounce(function() {
                var item = this.children.first();
                if (dropdownModule.is.active() && item) {
                  dropdownModule.remove.selectedItem();
                  var className = $.fn.dropdown.settings.className;
                  item.$el.addClass(className.selected);
                }
              })
            );
          }
        }

        // Used to update tabindex position
        this.$el.prop('tabindex', 0);
        this.$el.find(' > input.search').prop('tabindex', 0);
        var value;
        if (!this._hasSetInitialValue && this.getOption('defaultValueToFirstModel')) {
          value = _.first(this._filteredSortedModels());
          value = this.getValueForDropdown(value);
        } else {
          value = this.getValueForDropdown(this.value);
        }
        this._updateValue(value, this);
        this._hasSetInitialValue = true;
      },

      _customDropdownFilter: function(searchTerm, module) {
        if (module.can.show()) {
          module.show();
        }
      },

      onBeforeAddChild: function(childView) {
        if (typeof childView.bindings.get === 'function') {
          childView.collection = childView.bindings.get('collection');
        }

        childView.index = this.collection.indexOf(childView.model);
      },

      updateAttributes: function() {
        this.addClass('clearable', this.getBoolOption('clearable'))
          .addClass(this.getOption('color'), this.getBoolOption('color'))
          .addClass(
            this.getOption('floated') + ' floated',
            this.getBoolOption('floated') && this.getOption('mode') == 'button'
          )
          .addClass('floating', this.getBoolOption('floating'))
          .addClass('upward', this.getOption('direction') == 'up')
          .addClass('search', this.getBoolOption('search'))
          .addClass('fluid', this.getBoolOption('fluid'))
          .addClass(this.getOption('pointing') + ' pointing', this.getBoolOption('pointing'))
          .addClass(
            'icon',
            this.getBoolOption('icon') && this.getOption('icon') != 'dropdown' && !this.getBoolOption('text')
          )
          .addClass('selection', this.getOption('mode') == 'select' && !this.getBoolOption('inline'))
          .addClass('labeled', this.getBoolOption('labeled'))
          .addClass('button', this.getOption('mode') == 'button' && !this.getBoolOption('inline'))
          .addClass('inline', this.getBoolOption('inline'))
          .addClass('error', this.getBoolOption('error'))
          .addClass(this.getOption('state'), this.getBoolOption('state'))
          .addClass('disabled', this.getBoolOption('disabled'))
          .addClass('circular', this.getBoolOption('circular'))
          .addClass(this.getOption('size'), this.getBoolOption('size'))
          .addClass('inverted', this.getBoolOption('inverted'))
          .addClass('loading', this.getBoolOption('loading'))
          .addClass('basic', this.getBoolOption('basic'))
          .addClass('read-only', this.getBoolOption('readonly'));

        // If dropdown has the option to clear the selection, show the clear button
        // Does not apply to button dropdowns
        if (this.getOption('clearable') && this.value && this.getOption('mode') != 'button') {
          this.ui.clearBtn.show();
        } else {
          this.ui.clearBtn.hide();
        }
      },

      sanitizeModelFromDropdownCollection: function(value) {
        value = this.collection.get(value);
        if (
          this.value instanceof Backbone.Model &&
          value instanceof Backbone.Model &&
          this.value.id === value.id &&
          this.value.id != null
        ) {
          return this.value;
        }
        return value;
      },

      getValueModelForModel: function(value) {
        value = this.sanitizeModelFromDropdownCollection(value);
        if (this.getOption('modelValue')) {
          value = Mn._getValue(this.getOption('modelValue'), this, [value, this.collection, this.model]);
        } else if (this.useIdAsValue) {
          var model = this.collection ? this.collection.get(value) : value;
          return model ? model.id : null;
        }
        return value;
      },

      getValueForDropdown: function(value) {
        if (this.getOption('dropdownValue')) {
          value = Mn._getValue(this.getOption('dropdownValue'), this, [value, this.collection, this.model]);
        } else {
          value = this.collection ? this.collection.get(value) : value;
        }
        return value;
      },

      _updateValue: function(value, view) {
        if (value && this.getOption('mode') == 'button') {
          if (this.getOption('text')) {
            this.$el.dropdown('set value', this._getModelId(value));
          } else {
            this.$el.dropdown('set selected', this._getModelId(value));
          }
        } else if (value) {
          this.$el.dropdown('set selected', this._getModelId(value));
        } else {
          var $el = this.$el;

          if (this.getOption('mode') == 'select') {
            $el.dropdown('clear');
          } else {
            $el
              .dropdown('set value', '')
              .dropdown('remove activeItem')
              .dropdown('remove selectedItem');
          }

          _.defer(function() {
            $el.blur();
          });
        }
      },

      findItemByModel: function(model) {
        return this.$('.item[data-value="' + this._getModelId(model) + '"]');
      },

      _getModelId: function(model) {
        if (!model) {
          return null;
        }
        return model.id == null ? model.cid : model.id;
      },

      _getModelById: function(id, collection) {
        collection = collection || this.collection;
        var models = collection ? collection.models : [],
          model = null;

        for (var i = 0, len = models.length, m; i < len; i++) {
          m = models[i];
          if (this._getModelId(m) === id) {
            return m;
          }
          if (this._getPropertyForModel(m, 'collection')) {
            model = this._getModelById(id, this._getPropertyForModel(m, 'collection'));
          }
          if (model) {
            return model;
          }
        }
        return model;
      },

      _onDropdownChange: function(id, text, $choice) {
        var model = this._getModelById(id),
          self = this;

        if (this.getBoolOption('textColor')) {
          this.$('> .text').addClass(this.getOption('textColor'));
        }

        var $search = this.$('> input.search');
        if (document.activeElement === $search.get(0)) {
          _.defer(function() {
            $search.blur();
          });
        }

        var view = _.find(this._getNestedViews(), function(view) {
          return view.el === $choice.get(0);
        });

        if (view) {
          view._parent.value = this.getValueModelForModel(view.model);
          this.triggerMethod('item:select', view, view.model);
        } else {
          this.value = void 0;
        }
      },

      onDropdownHide: function() {
        var module = this.$el.data().moduleDropdown;
        if (module) {
        }
      },

      blur: function() {
        this.$el.dropdown('remove searchTerm');
        this.$el.blur();
      },

      focus: function() {
        this.$el.focus();
      },

      onClearBtnClick: function(ev) {
        // Avoid triggering dropdown
        ev.stopPropagation();

        this.value = null;
      },

      triggerItemPress: function(itemEl) {
        // Ignore if not in button mode
        if (this.getOption('mode') != BUTTON_MODE) {
          return;
        }

        var id = $(itemEl).data('value'),
          model = this._getModelById(id);

        if (model) {
          this.triggerMethod('press', model);
        }
      },

      onItemClick: function(ev) {
        this.triggerItemPress(ev.currentTarget);
      },
    },
    {
      _prepareDropdownModel: function(obj) {
        var modelType = String(obj.model || '');

        // Use the model property to specify the type of dropdown item
        delete obj.model;

        if (modelType == 'header') {
          return new DropDownHeaderModel(obj);
        } else if (modelType == 'divider') {
          return new DropDownDividerModel(obj);
        } else {
          return new Backbone.Model(obj);
        }
      },

      createCollection: function(items) {
        var model = null,
          collection = new Backbone.Collection([]);

        if (!_.isArray(items)) {
          return collection;
        }

        for (var i = 0, len = items.length; i < len; i++) {
          model = this._prepareDropdownModel(items[i]);

          collection.push(model);
        }

        return collection;
      },

      addHeaderToCollection: function(def, collection, index) {
        var header = new DropDownHeaderModel(def || {});

        index = index != null ? index : collection.length;

        collection.add(header, { at: index });

        return this;
      },

      addDividerToCollection: function(collection, index) {
        var divider = new DropDownDividerModel();

        index = index != null ? index : collection.length;

        collection.add(divider, { at: index });

        return this;
      },
    }
  );

  channel.reply('dropdown', function() {
    return Dropdown;
  });

  Dropdown.ItemView = DropDownItemView;

  Dropdown.HeaderModel = DropDownHeaderModel;
  Dropdown.DividerModel = DropDownDividerModel;

  Dropdown.BUTTON_MODE = BUTTON_MODE;
  Dropdown.SELECT_MODE = SELECT_MODE;

  module.exports = Dropdown;
});

